module.exports = __webpack_public_path__ + "img/v-outline.4cf39344.svg";